import React, { useContext } from "react";
import "./EmailStyle.scss";
import { emailTextContent } from "./constant/index";
import { LoginContext } from "context/context";
import { ProtectRoutesContext } from "context/ProtectRoutesContext";
import { Link, useNavigate } from "react-router-dom";
// import Lottie from "lottie-react";
// import aviatorAnimation from "../../assets/json-animation/Aviator.json";

const PageFooter = () => {
  const navigate = useNavigate()
  const { setOpenPasswordEntryModal } = useContext(LoginContext)
  const { isAuthenticated } = useContext(ProtectRoutesContext)

  const handleLinkClick = (e) => {
    e.preventDefault()
    if (isAuthenticated) {
      navigate('/slot-games-list')
    } else {
      setOpenPasswordEntryModal(true)
    }
  }
  return (
    <section className="email-section">
      <div className="email-wrap">
        {/* <div className="animation-wrap">
          <div className="animation-box animation-box-left">
            <Lottie className="lottie-animation-box" animationData={aviatorAnimation} loop={true} />
          </div>

          <div className="animation-box animation-box-right">
            <Lottie className="lottie-animation-box" animationData={aviatorAnimation} loop={true} />
          </div>
        </div> */}

        <div className="email-box">
          <a href="/" className="brand-logo-box">
            <img src={emailTextContent.brandLogo} alt="Img" />
          </a>

          <div className="btn-box">
            <a href={emailTextContent.email} className="email-btn">{emailTextContent.btnText}</a>
          </div>

          <Link href="#" onClick={handleLinkClick} className="know-more-btn">{emailTextContent.knowMoreBtnText}</Link>
        </div>
      </div>
    </section>
  );
};

export default PageFooter;
